export default class CrearCategoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(payload) {
    try {
      const result = await this.#repository.crearCategoria(payload)
      return result
    } catch (error) {
      throw error
    }
  }
}
